module.exports = __webpack_public_path__ + "img/dikidi.png";